import { render, staticRenderFns } from "./BaseUploadImage.vue?vue&type=template&id=c719f354&scoped=true&"
import script from "./BaseUploadImage.vue?vue&type=script&lang=js&"
export * from "./BaseUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadImage.vue?vue&type=style&index=0&id=c719f354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c719f354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c719f354')) {
      api.createRecord('c719f354', component.options)
    } else {
      api.reload('c719f354', component.options)
    }
    module.hot.accept("./BaseUploadImage.vue?vue&type=template&id=c719f354&scoped=true&", function () {
      api.rerender('c719f354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseUploadImage.vue"
export default component.exports